import React from 'react';
import { Box } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type DataVisualizationActionsProps = {
  isPreviewMode: boolean;
  onResetToUpload?: () => void;
  onUpload?: () => void;
  onDeleteUploadedData?: () => void;
  isUploading: boolean;
};

export const DataVisualizationActions: React.FC<
  DataVisualizationActionsProps
> = ({
  isPreviewMode,
  onResetToUpload,
  onUpload,
  onDeleteUploadedData,
  isUploading,
}) => {
  if (!isPreviewMode) {
    if (!onResetToUpload && !onDeleteUploadedData) {
      return null;
    }

    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="end"
        gap={4}
        mt={6}>
        {onDeleteUploadedData && (
          <Button
            buttonName="Delete uploaded data"
            onClick={onDeleteUploadedData}
            bg="background.red.500"
            color="white"
            borderRadius="lg"
            w={{ base: '100%', md: '220px' }}
            alignSelf="center"
            fontSize="16px"
            fontWeight={600}
            _hover={{ bg: 'red.600' }}>
            Delete uploaded data
          </Button>
        )}

        {onResetToUpload && (
          <Button
            buttonName="Upload more files"
            onClick={onResetToUpload}
            bg="surface.sidebarMuted"
            color="content.body"
            border="1px solid"
            borderColor="surface.border"
            borderRadius="lg"
            w={{ base: '100%', md: '200px' }}
            alignSelf="center"
            fontSize="16px"
            fontWeight={600}
            boxShadow="none"
            _hover={{ bg: 'sidebar.itemHoverBg' }}>
            Upload more files
          </Button>
        )}
      </Box>
    );
  }

  const showChooseDifferentFilesButton = Boolean(onResetToUpload);
  const showUploadButton = Boolean(onUpload);

  if (!showChooseDifferentFilesButton && !showUploadButton) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="row" justifyContent="end" gap={4} mt={6}>
      {showChooseDifferentFilesButton && (
        <Button
          buttonName="Choose different files"
          onClick={onResetToUpload}
          bg="surface.sidebarMuted"
          color="content.body"
          border="1px solid"
          borderColor="surface.border"
          borderRadius="lg"
          w={{ base: '100%', md: '220px' }}
          alignSelf="center"
          fontSize="16px"
          fontWeight={600}
          boxShadow="none"
          _hover={{ bg: 'sidebar.itemHoverBg' }}>
          Choose different files
        </Button>
      )}

      {showUploadButton && (
        <Button
          buttonName="Confirm & Upload"
          onClick={onUpload}
          bg="icon.green"
          color="white"
          borderRadius="lg"
          w={{ base: '100%', md: '200px' }}
          alignSelf="center"
          fontSize="16px"
          fontWeight={600}
          isDisabled={isUploading}
          _hover={{
            opacity: 0.9,
          }}
          _disabled={{
            bg: 'gray.400',
            cursor: 'not-allowed',
            opacity: 0.6,
          }}>
          {isUploading ? 'Uploading...' : 'Confirm & Upload'}
        </Button>
      )}
    </Box>
  );
};
